import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import QRCode from 'qrcode';

export const QrCode = forwardRef(({ data, downloadFileName, noRender }, ref) => {
  const [qr, setQr] = useState('');

  const generateCode = (qrData, customCallback) => {
    QRCode.toDataURL(
      qrData,
      {
        width: 300,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#ffffff',
        },
      },
      ((err, url) => {
        if (err) {
          return;
        }

        if (customCallback) {
          customCallback(url);
        } else {
          setQr(url);
        }
      }),
    );
  };

  const downloadFileFromUrl = (fileName, url) => {
    // eslint-disable-next-line no-undef
    const aTag = document.createElement('a');

    aTag.href = url;
    aTag.setAttribute('download', fileName || '');

    // eslint-disable-next-line no-undef
    document.body.appendChild(aTag);

    aTag.click();
    aTag.remove();
  };

  useEffect(() => {
    if (!noRender && data) {
      generateCode(data);
    }
  }, [data]);

  useImperativeHandle(ref, () => ({
    download() {
      downloadFileFromUrl(downloadFileName, qr);
    },
    renderAndDownload(qrData, fileName) {
      generateCode(qrData, (newQr) => {
        downloadFileFromUrl(fileName, newQr);
      });
    },
  }));

  if (noRender) {
    return null;
  }

  return (
    <img src={qr} alt={downloadFileName || 'qr code'} />
  );
});
